import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavigationButton } from '../Styled/GlobalStyles';
import { routeDefinition } from '../../routes';
import { Grid } from 'antd';

const { useBreakpoint } = Grid;

export const SideNavigationButton = ({ route }: { route: routeDefinition }) => {
  const screens = useBreakpoint();
  const collapsed = !screens.lg;

  const pathName = useLocation().pathname;
  let isActive = pathName === route.path;
  if (route.index && pathName === '/') {
    isActive = true;
  }
  return (
    <Link to={route.disabled ? '#' : route.path}>
      <NavigationButton
        isactive={isActive ? 'true' : 'false'}
        ghost={!isActive}
        type='primary'
        shape='round'
        icon={<FontAwesomeIcon icon={route.icon} size={'lg'} style={{ width: 20, marginLeft: collapsed ? 10 : 0 }} />}
        size='large'
        disabled={route.disabled}
        style={{
          fontWeight: 700,
        }}
      >
        {!collapsed && route.title}
      </NavigationButton>
    </Link>
  );
};
